import { render, staticRenderFns } from "./CarregandoGeral.vue?vue&type=template&id=1af3a470&scoped=true&"
import script from "./CarregandoGeral.vue?vue&type=script&lang=js&"
export * from "./CarregandoGeral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af3a470",
  null
  
)

export default component.exports